import React, {useRef, useLayoutEffect, useEffect} from 'react';
import leaflet from 'leaflet';
import {MapContainer, TileLayer, Popup, Marker} from 'react-leaflet';
import {createStyle} from '../../helpers/createTag';

import styles from './styles.module.css';

const MapComponent = ({latitude, longitude, zoom, content}) => {
  const _map = useRef(null);
  let icon;
  if (typeof window !== 'undefined') {
    icon = new leaflet.Icon({
      iconUrl: require('./assets/marker-icon.png'),
      iconRetinaUrl: require('./assets/marker-icon-2x.png'),
      shadowUrl: require('./assets/marker-shadow.png'),
      // shadowAnchor: null,
      shadowSize: [41, 41],
      iconSize: [25, 41],
      popupAnchor: [-8, -10],
      iconAnchor: [20, 10],
      className: 'leaflet-icon',
    });
  }
  useEffect(() => {
    createStyle('https://unpkg.com/leaflet@1.5.1/dist/leaflet.css');
  }, []);
  useLayoutEffect(() => {
    setTimeout(() => {
      if (_map.current) {
        _map.current.leafletElement.invalidateSize();
      }
    }, 100);
  }, []);

  const url = 'https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png';
  //"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  if (typeof window !== 'undefined') {
    const position = [latitude, longitude];
    return (
      <div className={styles.leaflet__map}>
        <MapContainer
          center={position}
          zoom={zoom}
          touchZoom
          ref={_map}
          scrollWheelZoom={false}
        >
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url={url}
          />
          <Marker position={position} icon={icon}>
            <Popup>{content}</Popup>
          </Marker>
        </MapContainer>
      </div>
    );
  }
  return null;
};

MapComponent.defaultProps = {
  latitude: 48.85837,
  longitude: 2.294481,
  zoom: 14,
  content: '',
};

export default MapComponent;
